export const validRouts: {
    role: string,
    SPID:number,
    tabs: string[]
}[] = [    
        {
            role: 'TLBLG',
            SPID: 94,
            tabs: ['EntityDashboard','UserMaster', 'CustomerMasters','CustomerAddEdit','EntityAddEdit','EntityBulkUpload', 'EntityMasters', 'AgreementDetail', 'MasterScopings', 'CommercialMappings', 'ActivityCalenders', 'MasterScopingSetup','MasterScoping','EntityMaster','AgreementDetails','CommercialMapping','ActivityCalender','CustomerUserMapping','ListOfEntities','MasterScopingEdit','CommercialMappingEdit','StateBillingMaster','StateBillingMasterEdit','PO','POAddEdit','CommercialMappingGrid','Invoice','Reports']
        },
        {
            role: 'TLFINP',
            SPID: 94,
            tabs: ['Invoice','Reports']
        },
        {
            role: 'TLFINR',
            SPID: 94,
            tabs: ['Invoice','Reports']
        }

    ]